/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './file-input.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@covalent/core/file/file-input/file-input.component';
import * as i3 from '../../../../@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/material';
import * as i5 from '@covalent/core/file/directives/file-drop.directive';
import * as i6 from '@covalent/core/file/directives/file-select.directive';
import * as i7 from '@angular/forms';
const styles_TdFileInputComponent:any[] = [i0.styles];
export const RenderType_TdFileInputComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdFileInputComponent,data:{}});
export function View_TdFileInputComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[i1.ɵqud(402653184,1,{_inputElement:0}),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),13,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),7,'button',[['class','td-file-input mat-raised-button'],
          ['md-raised-button',''],['tdFileDrop',''],['type','button']],[[8,'disabled',
          0],[1,'multiple',0],[1,'disabled',0]],[[(null as any),'keyup.enter'],[(null as any),
          'click'],[(null as any),'fileDrop'],[(null as any),'drop'],[(null as any),
          'dragover'],[(null as any),'dragenter'],[(null as any),'dragleave']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i2.TdFileInputComponent = _v.component;
        if (('drop' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,7).onDrop($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('dragover' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,7).onDragOver($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('dragenter' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,7).onDragEnter($event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('dragleave' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,7).onDragLeave($event)) !== false);
          ad = (pd_3 && ad);
        }
        if (('keyup.enter' === en)) {
          const pd_4:any = ((<any>i1.ɵnov(_v,12).click()) !== false);
          ad = (pd_4 && ad);
        }
        if (('click' === en)) {
          const pd_5:any = ((<any>i1.ɵnov(_v,12).click()) !== false);
          ad = (pd_5 && ad);
        }
        if (('fileDrop' === en)) {
          const pd_6:any = ((<any>_co.handleSelect($event)) !== false);
          ad = (pd_6 && ad);
        }
        return ad;
      },i3.View_MdButton_0,i3.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
      i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(180224,(null as any),0,i4.MdButton,[i1.ElementRef,i1.Renderer2,
      i4.Platform,i4.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},
      (null as any)),i1.ɵdid(16384,(null as any),0,i4.MdRaisedButtonCssMatStyler,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i5.TdFileDropDirective,
      [i1.Renderer2,i1.ElementRef],{multiple:[0,'multiple'],disabled:[1,'disabled']},
      {onFileDrop:'fileDrop'}),(_l()(),i1.ɵted(0,['\n    '])),i1.ɵncd(0,0),(_l()(),
      i1.ɵted(0,['\n  '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,
      [[1,0],['fileInput',1]],(null as any),1,'input',[['class','td-file-input-hidden'],
          ['tdFileSelect',''],['type','file']],[[1,'accept',0],[8,'disabled',0],[1,
          'multiple',0]],[[(null as any),'fileSelect'],[(null as any),'change']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i2.TdFileInputComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,13).onChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('fileSelect' === en)) {
          const pd_1:any = ((<any>_co.handleSelect($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i6.TdFileSelectDirective,
      [[8,(null as any)]],{multiple:[0,'multiple']},{onFileSelect:'fileSelect'}),(_l()(),
      i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.TdFileInputComponent = _v.component;
    const currVal_3:any = _co.disabled;
    const currVal_4:any = _co.color;
    _ck(_v,5,0,currVal_3,currVal_4);
    const currVal_5:any = _co.multiple;
    const currVal_6:any = _co.disabled;
    _ck(_v,7,0,currVal_5,currVal_6);
    const currVal_10:any = _co.multiple;
    _ck(_v,13,0,currVal_10);
  },(_ck,_v) => {
    var _co:i2.TdFileInputComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,5).disabled || (null as any));
    const currVal_1:any = i1.ɵnov(_v,7).multipleBinding;
    const currVal_2:any = i1.ɵnov(_v,7).disabledBinding;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2);
    const currVal_7:any = _co.accept;
    const currVal_8:any = _co.disabled;
    const currVal_9:any = i1.ɵnov(_v,13).multipleBinding;
    _ck(_v,12,0,currVal_7,currVal_8,currVal_9);
  });
}
export function View_TdFileInputComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-file-input',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdFileInputComponent_0,
      RenderType_TdFileInputComponent)),i1.ɵprd(5120,(null as any),i7.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.TdFileInputComponent]),i1.ɵdid(49152,(null as any),0,i2.TdFileInputComponent,
      [i1.Renderer2,i1.ChangeDetectorRef],(null as any),(null as any))],(null as any),
      (null as any));
}
export const TdFileInputComponentNgFactory:i1.ComponentFactory<i2.TdFileInputComponent> = i1.ɵccf('td-file-input',
    i2.TdFileInputComponent,View_TdFileInputComponent_Host_0,{color:'color',multiple:'multiple',
        accept:'accept',disabled:'disabled'},{onSelect:'select'},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/file/file-input/file-input.component.ngfactory.ts